import {ChevronDown} from 'lucide-react'
import { useState } from 'react'

const FAQS = [
  {
    q: 'How much alcohol do I need for 100 wedding guests?',
    a: 'For 100 guests at a 4-hour reception with 85% drinking, plan for roughly 340-380 standard drinks. That typically breaks down to about 4 cases of wine, 10-12 cases of beer, and 8-10 bottles of spirits, depending on your bar package.',
  },
  {
    q: 'How many bottles of wine do I need for 100 guests?',
    a: 'For a beer-and-wine bar serving 100 guests over 4 hours, expect to need approximately 40-50 bottles of wine (roughly 4 cases), split evenly between red and white unless a seasonal preference shifts the ratio.',
  },
  {
    q: 'What percentage of guests usually don\'t drink at a wedding?',
    a: 'On average, 10-20% of wedding guests do not drink alcohol due to age, health, religious reasons, or being designated drivers. Most planners use 80-85% as a safe estimate of drinking guests.',
  },
  {
    q: 'How many drinks fit in a 750ml bottle of liquor?',
    a: 'A standard 750ml liquor bottle contains about 16.9 standard 1.5oz shots, which is the baseline unit used to calculate how many spirit bottles your wedding bar needs.',
  },
  {
    q: 'Can I return leftover unopened alcohol after a wedding?',
    a: 'Many retailers, such as Total Wine & More, offer sale-or-return policies on unopened, full cases purchased for events. Policies vary by state and store, so confirm the return window and receipt requirements before your event.',
  },
  {
    q: 'How many kegs of beer do I need for 150 guests?',
    a: 'For 150 guests drinking beer over a 4-hour reception, you typically need roughly 2-3 half-barrel kegs (each yielding about 165 12oz servings), depending on how much of your bar mix is beer versus wine or spirits.',
  },
]

export default function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
      {FAQS.map((faq, i) => (
        <div
          key={faq.q}
          className="rounded-xl border border-[#D4AF37]/25 bg-white overflow-hidden"
          itemScope
          itemProp="mainEntity"
          itemType="https://schema.org/Question"
        >
          <button
            type="button"
            onClick={() => setOpenIndex(openIndex === i ? null : i)}
            aria-expanded={openIndex === i}
            className="w-full flex items-center justify-between text-left px-5 py-4 font-medium text-[#222222] hover:bg-[#F7EBE8]/50 transition-colors"
          >
            <span itemProp="name">{faq.q}</span>
            <ChevronDown
              className={`w-5 h-5 text-[#6B1D2F] transition-transform shrink-0 ml-3 ${openIndex === i ? 'rotate-180' : ''}`}
              aria-hidden="true"
            />
          </button>
          {openIndex === i && (
            <div
              className="px-5 pb-4 text-sm text-gray-600 leading-relaxed"
              itemScope
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer"
            >
              <span itemProp="text">{faq.a}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
